import { forwardRef } from 'react'

import { TextContainer } from 'components/container'
import { Section, Title } from 'components/misc'
import OlonkhoSrc from './assets/olonkho.webp'
import { Figure, Threaded } from './styled'

export const Olonkho = forwardRef<HTMLDivElement, {}>((_, ref) => (
  <Section ref={ref}>
    <TextContainer>
      <Title data-menu-title="олонхо">Олонхо</Title>

      <p>
        Олонхо – древнейшее эпическое искусство саха, признанное ЮНЕСКО в 2005 году одним из шедевров устного и нематериального наследия человечества. Он считается главным в системе национального фольклора и венцом словесного искусства саха.
      </p>
      <p>
        Олонхо исполняется без музыкального сопровождения, с чередованием речевых поющихся разделов. Помимо актерского и певческого мастерства, сказители должны обладать талантом к импровизации и ораторскому искусству. Партии персонажей поются в особой тональности, остальной текст декламируют почти речитативом, то ускоряя, то замедляя темп речи.
      </p>

      <Figure>
        <img src={OlonkhoSrc} alt="Olonkho" />
        <figcaption>
          Из серии "Якутский героический эпос". Худ.  Владимир Семенович Карамзин. 1969 год.
          <a
            href="https://artsandculture.google.com/story/1AWhze-aoQmYLQ?hl=ru"
            target="_blank"
          >
            Национальный художественный музей Республики Саха (Якутия)
          </a>
        </figcaption>
      </Figure>
    </TextContainer>
    <Threaded>
      <TextContainer>
        <p>
          Олонхо основан на преданиях о божественном племени Айыы, которое борется с племенем созданий тьмы – Абасы. Особенность олонхо заключается и в том, что главными героинями{' '}
          <a
            href="https://cyberleninka.ru/article/n/chudesnoe-rozhdenie-bogatyrki-kak-arhaicheskiy-motiv-v-yakutskih-olonho-o-zhenschinah-bogatyrkah/viewer"
            target="_blank"
            rel="noreferrer"
          >
            становятся и женщины
          </a>
          . Существует несколько десятков олонхо, в которых женщин представляют в образах шаманок и богатырок. Им не отводят роль пассивных героинь, ждущих спасения или замужества, а наоборот, наделяют могуществом, смелостью, силой и умом.
        </p>
        <p>
          Длина текстов в среднем составляет около 15 000 стихотворных строк. Самые крупные олонхо пелись в течение нескольких ночей. "Нюргун Боотур Стремительный" – наиболее известный олонхо, который состоит из 36 000 стихотворных строк, его автор – Платон Ойунский.
        </p>
      </TextContainer>
    </Threaded>
  </Section>
))
